import { useEffect } from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useSelector, useDispatch } from "react-redux";
import {
  selectProfile,
  selectProfileStatus,
  selectProfileError,
  fetchUserProfile,
} from "../redux/slices/profileSlice";
import { Link } from "react-router-dom";
import {
  fetchPaymentHistory,
  selectPayments,
} from "../redux/slices/paymentsSlice";

function Dashboard() {
  const dispatch = useDispatch();
  const profile = useSelector(selectProfile);
  const status = useSelector(selectProfileStatus);
  const error = useSelector(selectProfileError);
  const items = useSelector(selectPayments);

  useEffect(() => {
    dispatch(fetchPaymentHistory());
  }, [dispatch]);

  const totalPV = items.reduce((total, item) => {
    const base = item.taxBreakup?.baseAmount || 0;
    const qty = item.quantity || 1;
    return total + base * qty;
  }, 0);

  useEffect(() => {
    if (status === "idle" && !profile) {
      dispatch(fetchUserProfile());
    }
  }, [dispatch, status, profile]);

  return (
    <>
      <Header />

      <main>
        <section>
          <div className="container mt-1">
            <div className="row align-items-center">
              <div className="col-lg-9 col-12">
                <div className="d-flex align-items-center">
                  <div className="position-relative mt-4 me-3">
                    <img
                      src="/assets/images/profile.png"
                      alt=""
                      width="80"
                      height="80"
                      className="rounded-circle border object-fit-cover"
                    />
                  </div>
                  <div className="w-100 ms-md-2 mt-4">
                    <div className="d-flex justify-content-between">
                      <div>
                        <h1 className="mb-0 h2 lh-sm fw-medium">
                          {status === "succeeded" && profile?.name},{" "}
                          {status === "succeeded" && profile?.userId}
                          <Link to="/settings">
                            <i className="bi bi-gear text-danger fs-3 ms-3"></i>
                          </Link>
                        </h1>
                        <div className="d-flex">
                          <p className="mb-0 lh-sm">
                            {status === "succeeded" ? profile?.email : ""}
                            <br />
                            {status === "succeeded"
                              ? `(+91) ${profile?.phone}`
                              : ""}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 col-7">
                <div className="p-2 rounded-pill bg-dark mt-lg-0 mt-3 pe-8">
                  <Link
                    to="/wallet"
                    className="d-flex align-items-center justify-content-between"
                  >
                    <div className="d-flex align-items-center">
                      <div class="icon-shape icon-lg bg-white rounded-pill">
                        <i className="bi bi-wallet2 text-dark fs-3"></i>
                      </div>
                      <div className="ms-3">
                        <h3 class="mb-0 text-white lh-sm fs-5">
                          My Wallet &nbsp;[
                          {Math.floor(
                            ((profile?.successfulReferrals || 0) * 200 +
                              (profile?.selfBusiness || 0)) /
                              600,
                          )}{" "}
                          PV]
                        </h3>
                        <span className="text-white opacity-75 mb-0">
                          {profile?.milestoneLevel || 0} Level
                        </span>
                      </div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section>
          <div className="container mt-4">
            <div className="row g-2">
              <div className="col-lg-6 col-12">
                <div className="rounded-4 card shadow border border-light p-5 h-100">
                  <span class="text-primary d-block text-uppercase fw-semibold ls-lg fs-6">
                    My Referals
                  </span>
                  <h3 class="mb-0 lh-sm  fw-semibold">
                    {profile?.directReferrals} Direct Referals
                    <img
                      src="https://cdn-icons-png.flaticon.com/512/8207/8207939.png"
                      width="23"
                      className="ms-2"
                    />
                  </h3>
                  <p class="fs-5 mb-0 lh-sm ls-sm pe-5 mb-3">
                    Share with your friends / family to earn points.
                  </p>
                  <div>
                    <Link
                      to="/network"
                      className="btn btn-outline-dark btn-sm rounded-pill px-4 mt-1"
                    >
                      <i className="bi bi-graph-up me-2"></i>
                      Network / Earning History
                    </Link>
                  </div>
                  {/* 
                  <div className="d-flex flex-wrap gap-2">
                    <div className="pe-8 ps-2 py-2 rounded-pill bg-light">
                      <div className="d-flex align-items-center">
                        <div class="icon-shape icon-lg bg-light-primary rounded-circle">
                          <img
                            src="https://geeksui.codescandy.com/geeks/assets/images/avatar/avatar-4.jpg"
                            alt="chrome"
                            class="icon-lg rounded-circle"
                          />
                        </div>
                        <div className="ms-3">
                          <h3 class="mb-0 text-dark lh-1 fs-5">Manish Yadav</h3>
                          <span className="text-success">+452 Points</span>
                        </div>
                      </div>
                    </div>
                    <div className="pe-8 ps-2 py-2 rounded-pill bg-light">
                      <div className="d-flex align-items-center">
                        <div class="icon-shape icon-lg bg-light-primary rounded-circle">
                          <img
                            src="https://geeksui.codescandy.com/geeks/assets/images/avatar/avatar-2.jpg"
                            alt="chrome"
                            class="icon-lg rounded-circle"
                          />
                        </div>
                        <div className="ms-3">
                          <h3 class="mb-0 text-dark lh-1 fs-5">Priya Roy</h3>
                          <span className="text-success">+156 Points</span>
                        </div>
                      </div>
                    </div>
                    <div className="pe-8 ps-2 py-2 rounded-pill bg-light">
                      <div className="d-flex align-items-center">
                        <div class="icon-shape icon-lg bg-light-primary rounded-circle">
                          <img
                            src="https://geeksui.codescandy.com/geeks/assets/images/avatar/avatar-3.jpg"
                            alt="chrome"
                            class="icon-lg rounded-circle"
                          />
                        </div>
                        <div className="ms-3">
                          <h3 class="mb-0 text-dark lh-1 fs-5">
                            Shristi Kumari
                          </h3>
                          <span className="text-success">+986 Points</span>
                        </div>
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>

              <div className="col-lg-6 col-12">
                <div className="rounded-4 card shadow border border-light p-5 h-100">
                  <span class="text-primary d-block text-uppercase fw-semibold ls-lg fs-6">
                    My Order History
                  </span>
                  <h3 class="mb-0 lh-sm  fw-semibold">{items.length} Orders</h3>
                  <p class="fs-5 mb-0 lh-sm ls-sm pe-5 mb-3">
                    Product purchased will be visible in your Order History.
                  </p>
                  <div>
                    <Link
                      to="/orders"
                      className="btn btn-outline-dark btn-sm rounded-pill px-4 mt-1"
                    >
                      <i className="bi bi-wallet2 me-2"></i>
                      Order History
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

export default Dashboard;
